/**
 * Busca de CEP e CNPJ — dado público de terceiro, só para poupar digitação.
 *
 * Nunca é a fonte de verdade: o que volta daqui preenche campos que a pessoa
 * ainda pode corrigir antes de salvar. Falha aqui não é erro de formulário —
 * é "não deu para adiantar o preenchimento", e a tela segue em branco.
 */
import { api, ErroApi } from './api'

export type Endereco = {
  cep: string
  logradouro: string
  complemento: string
  bairro: string
  cidade: string
  uf: string
}

export type DadosCNPJ = {
  cnpj: string
  razao_social: string
  nome_fantasia: string
  situacao: string
  telefone?: string
  email?: string
  cep: string
  logradouro: string
  numero: string
  complemento: string
  bairro: string
  cidade: string
  uf: string
}

/** Busca endereço pelo CEP. `null` quando não encontrado ou o serviço falhou. */
export async function buscarCEP(cep: string, sinal?: AbortSignal): Promise<Endereco | null> {
  const digitos = cep.replace(/\D/g, '')
  if (digitos.length !== 8) return null

  try {
    return await api.get<Endereco>(`/auxiliares/cep/${digitos}`, sinal)
  } catch (causa: unknown) {
    if (causa instanceof DOMException && causa.name === 'AbortError') throw causa
    return null
  }
}

/** Busca dados cadastrais pelo CNPJ. `null` quando não encontrado ou o serviço falhou. */
export async function buscarCNPJ(cnpj: string, sinal?: AbortSignal): Promise<DadosCNPJ | null> {
  const digitos = cnpj.replace(/\D/g, '')
  if (digitos.length !== 14) return null

  try {
    return await api.get<DadosCNPJ>(`/auxiliares/cnpj/${digitos}`, sinal)
  } catch (causa: unknown) {
    if (causa instanceof DOMException && causa.name === 'AbortError') throw causa
    if (causa instanceof ErroApi) return null
    return null
  }
}
